import Cookie from 'cookie';

export async function initAuthState({commit, dispatch}, {req}) {
  const cookies = Cookie.parse(req.headers?.cookie || '')
  const haveTokenOrRefreshToken = cookies['adminToken'];

  if (haveTokenOrRefreshToken) {
    commit('setLogged', true);
    await dispatch('getUserInfo')
  }
}

export async function getUserInfo({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.users.info();
  if (!errResponse && responseData.success) {
    return commit('setUser', responseData?.data || null);
  }
}

export async function login({dispatch, commit}, payload) {
  commit('setBtnLoading', true, {root: true});

  let isSuccess = false;
  let message;

  try {
    const {errResponse, data: responseData} = await this.$adminRepositories.users.login(payload);

    if (!errResponse && responseData.success) {
      isSuccess = true;
      const tokenBearer = responseData.data.access_token;

      await dispatch('saveAuth', {tokenBearer});
      commit('setLogged', true);
      await dispatch('getUserInfo');
    }

    message = responseData.message;
  } catch (e) {
    isSuccess = false;

    const responseData = e.response.data;
    message = responseData.hasOwnProperty('data')
      ? Object.values(responseData.data)[0][0]
      || 'Server Error' : responseData.message;
  }

  commit('setBtnLoading', false, {root: true});

  return commit('setLogin', {
    isSuccess,
    message,
    isAlert: true
  });
}

export async function logout({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.users.logout();
  if (!errResponse && responseData.success) {
    commit('setUser', null);
    commit('setToken', null);
    commit('setLogged', false);
    return true;
  }

  return false;
}

export async function saveAuth({commit, dispatch}, payload) {
  const tokenBearer = payload.tokenBearer;
  commit('setToken', tokenBearer);
  commit('setLogged', true);
}